import { render, staticRenderFns } from "./FormulateTags.vue?vue&type=template&id=470ef83e&"
import script from "./FormulateTags.vue?vue&type=script&lang=js&"
export * from "./FormulateTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('470ef83e')) {
      api.createRecord('470ef83e', component.options)
    } else {
      api.reload('470ef83e', component.options)
    }
    module.hot.accept("./FormulateTags.vue?vue&type=template&id=470ef83e&", function () {
      api.rerender('470ef83e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/formulate/tags/FormulateTags.vue"
export default component.exports